let rootUrl = '/img';

export const imagesRoot = (val?: string) => {
  if (val) rootUrl = val;
  return rootUrl;
};

export const getImageUrl = (path: string) => {
  return `${imagesRoot()}/${path}`;
};
